<template>
  <div class="why-now-modal">
    <h2 class="why-now-modal__title">
      {{ texts.title }}
    </h2>
    <p class="why-now-modal__text" v-html="texts.text" />
    <base-button
      type="red"
      :is-bold="false"
      @click="onClose"
    >
      {{ texts.cta }}
    </base-button>
  </div>
</template>

<script setup lang="ts">
defineProps({
  texts: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['action']);

const { toggleComponent } = useModals();

function onClose() {
  toggleComponent();
  emit('action');
}
</script>

<style lang="scss" scoped>
.why-now-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: $white;
  padding: 24px;

  border-radius: 8px;

  width: 85%;
  max-width: 414px;

  &__title {
    text-align: center;
    font-family: $primary-fonts;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 135%; /* 27px */
    margin-bottom: 16px;
  }
  &__text {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    opacity: 0.75;
    margin-bottom: 32px;
  }

  & button {
    width: fit-content !important;
    margin: 0 auto;
    padding: 16px 66px;
  }
}
</style>
